/* THIS FILE IS AUTO-GENERATED – DO NOT EDIT */

import type {ComponentPropsWithRef, ReactElement} from 'react'

/**
 * @public
 */
export function StarIcon(props: ComponentPropsWithRef<'svg'>): ReactElement {
  return (
    <svg
      data-sanity-icon="star"
      width="1em"
      height="1em"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.5 5L14.3956 9.89092L19.6329 10.1824L15.5672 13.4966L16.9084 18.5676L12.5 15.725L8.09161 18.5676L9.43284 13.4966L5.36708 10.1824L10.6044 9.89092L12.5 5Z"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinejoin="round"
      />
    </svg>
  )
}

export {StarIcon as default}
